import {createContext, useContext} from "react";

const BusinessOnboardingContext = createContext(null);

export const useBusinessOnboardingContext = () =>
  useContext(BusinessOnboardingContext);

export default BusinessOnboardingContext;
